var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay_box"},[(_vm.success)?_c('div',{staticClass:"user_teacher"},[_c('div',{staticClass:"flexbox img_qrcode"},[_c('img',{staticClass:"img",attrs:{"src":_vm.user.adviserErCode}})]),_c('div',{staticClass:"img_text"},[_vm._v("请务必"+_vm._s(_vm.isNative ? '截图' : '')+"扫码进入班级群")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }